import React, { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const lang = useSelector((state) => state.settings.lang);

  useEffect(() => {
    document.title = lang === "de" ? "Seite nicht gefunden" : "Page not found";
  }, [lang]);

  const navigate = useNavigate();
  return (
    <div id="maincontent" className="page-main" style={{ paddingTop: "5px" }}>
      <a id="contentarea" tabIndex={-1} />
      <div className="page-title-wrapper">
        <h1 className="page-title">
          <span className="base" data-ui-id="page-title-wrapper">
            <FormattedMessage id="Page not found" />
          </span>{" "}
        </h1>
      </div>
      <div className="page messages">
        <div data-placeholder="messages" />
        <div data-bind="scope: 'messages'"></div>
      </div>
      <div className="columns">
        <div className="column main">
          <input
            name="form_key"
            type="hidden"
            defaultValue="Sk3VlxqpWwfVfRQk"
          />
          <div
            id="authenticationPopup"
            data-bind="scope:'authenticationPopup', style: {display: 'none'}"
            style={{ display: "none" }}
          ></div>
          <h2>
            <FormattedMessage id="404 page not found" />
          </h2>
          <p style={{ fontSize: "16px" }}>
            <FormattedMessage
              id="404 message"
              values={{
                a: (...chunks) => {
                  return (
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate(`/store/${lang}`);
                      }}
                    >
                      {" "}
                      {chunks}
                    </a>
                  );
                },
                b: (...chunks) => {
                  return (
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        navigate(`/store/${lang}`);
                      }}
                      href="#"
                    >
                      {" "}
                      {chunks}
                    </a>
                  );
                },
              }}
            />
          </p>
          <ul style={{ fontSize: "16px" }}>
            <li>
              <a href="https://store.eclear.com/en/catalogsearch/advanced/">
                <FormattedMessage id="Search" />
              </a>
            </li>
            <li>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  navigate(`/store/${lang}`);
                }}
              >
                <FormattedMessage id="Homepage" />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
